import React from "react";
import "./Home.css";
import wgb from "../images/banners/wgb.jpg";
import mtutourism from "../images/banners/mtutourism.jpg";

export const Venue = () => {
  return (
    <>
      <div className="page-layout">
        <div className="text-layout">
          <h2>Venue</h2>
          <p>
            IEEE SmartComp 2025 will be held in Cork City in Ireland from 16th
            to 19th June. It will be held over two venues with the workshops on
            16th June to take place in the Tourism & Hospitality Building in
            Munster Technological University. The remaining days of the
            conference will take place in the Western Gateway Building in
            University College Cork.
          </p>
          <h3>Tourism & Hospitality Building, MTU</h3>
          <p>
            The Tourism and Hospitality Building is located on the main campus
            of MTU in Bishopstown Cork. It is serviced by the{" "}
            <a href="https://www.buseireann.ie/routes-and-timetables/205">
              205
            </a>{" "}
            and{" "}
            <a href="https://www.buseireann.ie/routes-and-timetables/220">
              220
            </a>{" "}
            bus routes.
          </p>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2462.6490268901593!2d-8.537832522880116!3d51.8856188719018!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x484491de3e5adc79%3A0xb68a5829a79a194c!2sTourism%20Building!5e0!3m2!1sen!2sie!4v1736425041657!5m2!1sen!2sie"
            width="100%"
            height="450"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
          <img src={mtutourism} className="venue-img" />

          <h3>Western Gateway Building, UCC</h3>
          <p>
            The Western Gateway Building is located on the Western Road, Cork.
            It is serviced by the
            <a href="https://buseireann.ie/routes-and-timetables/208">
              208
            </a>,{" "}
            <a href="https://www.buseireann.ie/routes-and-timetables/220">
              220
            </a>
            , and{" "}
            <a href="https://www.buseireann.ie/routes-and-timetables/220x">
              220x
            </a>{" "}
            bus routes.
          </p>

          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2462.224229047641!2d-8.502543522879721!3d51.89337197190381!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4844902fb71b68ab%3A0xf0f414af69055988!2sWestern%20Gateway%20Building!5e0!3m2!1sen!2sie!4v1736424335196!5m2!1sen!2sie"
            width="100%"
            height="450"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
          <img src={wgb} className="venue-img" />
        </div>
      </div>
    </>
  );
};
